import Vue from 'vue'
import { SET_SITE,ALL_SET_SITE, ACCESS_TOKEN, ACCESS_HEADER, TENANT_ID,USER_INFO, SET_NUMBER_TYPE_OPTIONS} from "@/store/mutation-types"
import {login, logout, permission, userSitesl,allSitesl} from '@/api/app'
import { getNumberIntervalType } from '@/api/numberInterval'
import { addChildrenKey } from "@/utils/tree"
const user = {
  state: {
    siteInfo:"",
    numberTypeOptions: [],
    token: '',
    username: '',
    userId:'',
    realname: '',
    tenantid:'',
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {},
    // 系统安全模式
    sysSafeMode: null,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, id, realname, welcome }) => {
      state.username = username
      state.userId = id
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
      Vue.ls.set(USER_INFO, info)
    },
    SET_SITE: (state, info) => {
      Vue.ls.set(SET_SITE, info)
      state.siteInfo = info
    },
    ALL_SET_SITE: (state, info) => {
      Vue.ls.set(ALL_SET_SITE, info)
      state.allSiteInfo = info
    },
    SET_NUMBER_TYPE_OPTIONS: (state, options) => {
      Vue.ls.set(SET_NUMBER_TYPE_OPTIONS, options)
      state.numberTypeOptions = options
    },
    SET_TENANT: (state, id) => {
      state.tenantid = id
    },
    SET_SYS_SAFE_MODE: (state, sysSafeMode) => {
      if (typeof sysSafeMode === 'boolean') {
        state.sysSafeMode = sysSafeMode
      } else {
        state.sysSafeMode = false
      }
    },
  },

  actions: {
    // CAS验证登录
    ValidateLogin() {
      return new Promise((resolve) => {
        resolve();
        // getAction("/sys/cas/client/validateLogin",userInfo).then(response => {
        //   console.log("----cas 登录--------",response);
        //   if(response.success){
        //     const result = response.result
        //     const userInfo = result.userInfo
        //     Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
        //     Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
        //     Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
        //     commit('SET_TOKEN', result.token)
        //     commit('SET_INFO', userInfo)
        //     commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
        //     commit('SET_AVATAR', userInfo.avatar)
        //     resolve(response)
        //   }else{
        //     resolve(response)
        //   }
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise( (resolve, reject) => {
        //   Vue.ls.set(ACCESS_TOKEN, "12122", 7 * 24 * 60 * 60 * 1000)
        //   Vue.ls.set(USER_NAME, "zhaiwc", 7 * 24 * 60 * 60 * 1000)
        //   Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
        //   commit('SET_TOKEN', "12122")
        //   commit('SET_INFO', {})
        //   commit('SET_NAME', { username: "zhaiwc",realname: "c-zhaiwc", welcome: "" })
        //   commit('SET_AVATAR', "https://123")
        // resolve()

        login(userInfo).then(response => {
          if(response.code =='200'){
            const result = response.data
            // const userInfo = result.userInfo
            const expireTime = result.expireTime;
            Vue.ls.set(ACCESS_TOKEN, result.token, expireTime * 60 * 1000)
            Vue.ls.set(ACCESS_HEADER, result.header, expireTime * 60 * 1000)
            // Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            // Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            // Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            // commit('SET_INFO', userInfo)
            // commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            // commit('SET_AVATAR', userInfo.avatar)
            return response
          }else{
            reject(response)
          }
        }).then(() => {
          userSitesl().then(siteResponse => {
            if(siteResponse.code == "200"){
              commit('SET_SITE', siteResponse.data)
              resolve(siteResponse)
            }else{
              reject(siteResponse)
            }
          });
          allSitesl().then(siteResponse => {
            if(siteResponse.code == "200"){
              commit('ALL_SET_SITE', siteResponse.data)
              resolve(siteResponse)
            }else{
              reject(siteResponse)
            }
          });
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetPermissionList({ commit }) {
      return new Promise((resolve, reject) => {
        permission().then(response => {
          if(response.code =='200'){
            const menuData = response.data
            let menusPonse = menuData.menus, userPonse = menuData.user, rolesPonse = menuData.roles;
            console.log("userPonse", userPonse, rolesPonse,menusPonse)
            const mateChildOptions = addChildrenKey(menusPonse, "children")


            commit('SET_INFO', userPonse)
            // 拼接数据
            commit('SET_PERMISSIONLIST', mateChildOptions)
            // 设置系统安全模式
            commit('SET_SYS_SAFE_MODE', true)
            resolve(mateChildOptions)
          }else{
            reject('GetPermissionList: permissions must be a non-null array !')
          }
        })
      })
    },

    // 登出
    Logout({ commit, state}) {
      return new Promise((resolve, reject) => {

        // Vue.ls.remove(USER_INFO)
        // Vue.ls.remove(USER_NAME)
        // Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
        // Vue.ls.remove(CACHE_INCLUDED_ROUTES)
        // Vue.ls.remove(TENANT_ID)
        // resolve()
        logout().then((response) => {
          if(response.code =='200'){
            let logoutToken = state.token;
            console.log('logoutToken: '+ logoutToken)
            commit('SET_TOKEN', '')
            commit('SET_PERMISSIONLIST', [])
            Vue.ls.remove(ACCESS_TOKEN)
            Vue.ls.remove(SET_SITE)
            Vue.ls.remove(ACCESS_HEADER)
            resolve()
          }else{
            reject(response.msg)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 获取号码类型选项
    GetNumberTypeOptions({ commit }) {
      return new Promise((resolve, reject) => {
        getNumberIntervalType({}).then(response => {
          if(response && response.code) {
            commit('SET_NUMBER_TYPE_OPTIONS', response.data || [])
            resolve(response.data || [])
          } else {
            reject('获取号码类型选项失败')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    saveTenant({ commit }, id){
      Vue.ls.set(TENANT_ID, id, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TENANT', id)
    }


  }
}

export default user
